
import { Vue, Component } from 'vue-property-decorator';

@Component({ name: 'GuidePage' })
export default class GuidePage extends Vue {
  mounted(): void {
    const el = document.querySelector('.auth-layout') as HTMLElement | null;
    if (el) el.style.overflow = 'auto';
  }

  beforeDestroy(): void {
    const el = document.querySelector('.auth-layout') as HTMLElement | null;
    if (el) el.style.overflow = '';
  }
}
